<template>
  <div class="details-container">
    <b-row>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity' | i18n }} 6:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity6 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity' | i18n }} 7:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity7 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity' | i18n }} 8:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity8 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity' | i18n }} 9:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity9 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity' | i18n }} 10:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity10 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity' | i18n }} 11:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity11 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity' | i18n }} 12:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity12 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'from_quantity_without_price' | i18n }} 13:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.fromQuantity13WithoutPrice }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 6:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount6 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 7:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount7 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 8:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount8 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 9:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount9 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 10:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount10 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 11:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount11 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 12:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount12 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount_without_price' | i18n }} 13:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount13WithoutPrice }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BCol, BRow} from 'bootstrap-vue';

export default {
  name: 'QuantityScaleDetailsRow',
  components: {'b-row': BRow, 'b-col': BCol},
  props: {
    row: {
      type: Object,
      default: () => {
      }
    }
  }
};
</script>

<style scoped>

</style>
